import { RootState } from 'src/store';

const getLmsConfigState = (state: RootState) => state?.lmsConfig;

export const getWorkflowActionState = (state: RootState) =>
  getLmsConfigState(state)?.workflowActionState;

export const getWorkflowActionMessage = (state: RootState) =>
  getLmsConfigState(state)?.workflowActionMessage;

export const getInputFields = (state: RootState) =>
  getLmsConfigState(state)?.inputFields;

export const getSelectedMenu = (state: RootState) =>
  getLmsConfigState(state)?.selectedMenu;

export const getHierarchy = (state: RootState) =>
  getLmsConfigState(state)?.hierarchy;

export const getAllUsers = (state: RootState) =>
  getLmsConfigState(state)?.allUsers;

export const getUsers = (state: RootState) => getLmsConfigState(state)?.users;

export const getReferrals = (state: RootState) =>
  getLmsConfigState(state)?.referrals;

export const getRevyreConfig = (state: RootState) =>
  getLmsConfigState(state)?.revyreConfig;

export const getRevyreWorkflowConfig = (state: RootState) =>
  getLmsConfigState(state)?.revyreWorkflowConfig || {};

export const getPendingActivities = (state: RootState) =>
  getLmsConfigState(state)?.pendingActivities || [];

export const getPerformanceCards = (state: RootState) =>
  getLmsConfigState(state)?.performanceCards || [];
